import indexFrame from 'page/qa/indexFrame'
// import recommendedQuestion from 'page/qa/recommendedQuestion'
// import realTimeTopicsList from 'page/qa/realTimeTopicsList'
// import realTimeTopicsDetail from 'page/qa/realTimeTopicsDetail'
// import realTimeStoryDetail from 'page/qa/realTimeStoryDetail'
// import comment from 'page/qa/comment-answer'
// import myStory from 'page/qa/shareMyStory'
// import subCommunity from 'page/qa/subCommunity'
const recommendedQuestion = () =>
  import(
    /* webpackChunkName: "qa~recommendedQuestion" */ 'page/qa/recommendedQuestion'
  )
const realTimeTopicsList = () =>
  import(
    /* webpackChunkName: "qa~realTimeTopicsList" */ 'page/qa/realTimeTopicsList'
  )
const realTimeTopicsDetail = () =>
  import(
    /* webpackChunkName: "qa~realTimeTopicsDetail" */ 'page/qa/realTimeTopicsDetail'
  )
const realTimeStoryDetail = () =>
  import(
    /* webpackChunkName: "qa~realTimeStoryDetail" */ 'page/qa/realTimeStoryDetail'
  )
const comment = () =>
  import(/* webpackChunkName: "qa~comment" */ 'page/qa/comment-answer')
const myStory = () =>
  import(/* webpackChunkName: "qa~myStory" */ 'page/qa/shareMyStory')
const subCommunity = () =>
  import(/* webpackChunkName: "qa~subCommunity" */ 'page/qa/subCommunity')

const fenguan = () =>
  import(/* webpackChunkName: "qa~fenguan" */ 'page/qa/fenguan')

const postQuestionView = () =>
  import(
    /* webpackChunkName: "qa~fenguan" */ 'page/qa/questions/postQuestionView'
  )

const routes = [
  {
    path: '/qa/',
    component: indexFrame,
    children: [
      {
        path: 'tag_:tagId',
        component: recommendedQuestion,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      },
      {
        path: 'real_time_topics_list',
        component: realTimeTopicsList,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      },
      {
        // 7.1.0心理圈发布页面新增“添加故事集/书写计划”按钮;发布心理圈同步发布到故事，选择故事的路由
        path: 'syncPsychologyCircle',
        name: 'syncPsychologyCircle',
        component: realTimeTopicsList,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      },
      // 老的URL，保留不删。
      {
        path: 'real_time_topics_detail/:topic_id',
        redirect: to => {
          return `real_time_topics_detail_${to.params.topic_id}`
        }
      },
      // SEO优化后的新url，今后跳转统一用这个。
      {
        path: 'real_time_topics_detail_:topic_id',
        component: realTimeTopicsDetail,
        meta: {
          cache: false,
          // cache: 10 * 60 * 1000
          business: '故事集',
          pageName: '故事列表页',
          disableStatPageName: true
        }
      },
      {
        path: 'real_time_story_detail/:story_id',
        component: realTimeStoryDetail,
        meta: {
          cache: false,
          // cache: 10 * 60 * 1000
          business: '故事集',
          pageName: '故事详情页',
          disableStatPageName: true
        }
      },
      {
        path: 'comment',
        component: comment,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      },
      {
        path: 'my_story',
        component: myStory,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      },
      {
        path: 'sub_community/:id', // 子社区运营不维护了
        component: subCommunity,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      },
      {
        path: 'fenguan', // 子社区运营不维护了
        component: fenguan,
        meta: {
          cache: 10 * 60 * 1000
        }
      },
      {
        path: 'postQuestionView',
        name: 'postQuestionView',
        component: postQuestionView,
        meta: {
          cache: false
          // cache: 10 * 60 * 1000
        }
      }
    ]
  }
]

export default routes
